import { COLORS } from '@btime/constants'
import React from 'react'

import HelpFixedButton from '../../containers/help/HelpFixedButton'

export const AbsolutePageTemplateWithoutControls = ({ children, bgColor }) => {
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 999,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        minHeight: '100vh',
        backgroundColor: bgColor || COLORS.light1
      }}
    >
      {children}
      <HelpFixedButton />
    </div>
  )
}
const AbsolutePageTemplate = ({ children, bgColor }) => {
  // useStyleControl('app-header', 'display', 'none')
  // useStyleControl('app-menu', 'display', 'none')
  // useStyleControl('.m-b-10', 'display', 'none');
  // useStyleControl('mat-sidenav', 'display', 'none');
  // useStyleControl('mat-sidenav-content', 'padding', 0);
  // useStyleControl('mat-sidenav-content', 'margin', 0);
  // useStyleControl('mat-sidenav-content', 'margin-left', 0);
  // useStyleControl('.page-wrapper', 'margin', 0);
  // useStyleControl('.pcoded-inner-content', 'padding', 0);
  // useStyleControl('.page-wrapper', 'padding', 0);
  // useStyleControl('.pcoded-content', 'position', 'static')
  // useStyleControl('.pcoded-main-container', 'margin-top', '0')
  // useStyleControl('mat-sidenav-content', 'position', 'static')
  // useStyleControl('mat-sidenav-content', 'height', '100vh')

  return <AbsolutePageTemplateWithoutControls children={children} bgColor={bgColor} />
}

export default AbsolutePageTemplate
